import { enableNetworkRetryLink } from '../src/links/NetworkErrorRetryLink.ts';
import { enableStatusCodeRetryLink } from '../src/links/StatusCodeRetryLink.ts';

export function enableGraphqlRetries() {
	enableNetworkRetryLink();
	enableStatusCodeRetryLink();
}
